/**
 * Users Service (Web)
 * 
 * Chức năng: Service để gọi API liên quan đến nhân sự (users) cho web app
 * Dùng để: 
 * - CRUD operations cho users
 * - Tích hợp với WebApiService
 */
import { UsersService } from '@shared/services/users.service';
import { API_URL } from '../config/constants';
import { STORAGE_KEYS } from '@shared/constants';

class WebUsersService extends UsersService {
  protected getBaseURL(): string {
    return API_URL;
  }

  protected async getAuthToken(): Promise<string | null> {
    return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
  }

  protected async handleUnauthorized(_message?: string): Promise<void> {
    // Clear token and redirect to login
    localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
    window.location.href = '/login';
  }
}

export const usersService = new WebUsersService();

